module.exports = __webpack_public_path__ + "img/logo.d857093e.png";